import { render, staticRenderFns } from "./TextHighlighter.vue?vue&type=template&id=6fa47d88&scoped=true&"
import script from "./TextHighlighter.vue?vue&type=script&lang=js&"
export * from "./TextHighlighter.vue?vue&type=script&lang=js&"
import style0 from "./TextHighlighter.vue?vue&type=style&index=0&id=6fa47d88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa47d88",
  null
  
)

export default component.exports